export class PartnerUtils {

  static computeDateRelativeTo(templateDate: Date, newDateStart: Date, templateDateStart: Date) {
    return templateDate
      ? new Date(
        newDateStart.getTime() - (new Date(templateDateStart).getTime() - new Date(templateDate).getTime()),
      )
      : undefined;
  }

}
